import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/enquiries")({
  component: lazyRouteComponent(() => import("@/pages/admin/Enquiries")),
});
